import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], key: string, text: string): any[] {
    if (!items) {
      return [];
    }

    if (!text || !key) {
      return items;
    }

    return items.filter((item) => item[key] === text);
  }
}
